<template>
  <div class="row" style="margin-bottom: 1.75rem;">
    <div class="col-md-12">
      <div style="border: 1px solid #EBEDF3; border-radius: 0.42rem; padding: 16px;">
        <h3 class="card-label" style="margin-bottom: 1.75rem;">GED</h3>

        <b-form-group
          v-show="!loadingGED"
          v-if="fluxoDetalhadoGEDs.length"
          label="Arquivos Anexados (GED):"
        >
          <b-list-group>
            <b-list-group-item
              v-for="fluxoDetalhadoGED in fluxoDetalhadoGEDs"
              :key="fluxoDetalhadoGED.ID_GED"
            >
              <div>
                <b-badge
                  class="mr-1"
                  variant="primary"
                  style="margin-bottom: 10px; padding: 4px;"
                >
                  Incluído em:
                  {{ formataDataPadrao(fluxoDetalhadoGED.DATA_INCLUSAO) }}
                </b-badge>
              </div>
              <span class="svg-icon svg-icon-lg" style="margin-right: 7px;">
                <inline-svg src="media/svg/icons/Files/File-cloud.svg" />
              </span>
              <a @click="baixarArquivo(fluxoDetalhadoGED)" href="javascript:;">
                {{ fluxoDetalhadoGED.NOME_ARQUIVO }}
              </a>
              <span style="margin-left: 10px;"
                >{{
                  (fluxoDetalhadoGED.TAMANHO / 1024 / 1024).toFixed(2)
                }}MB</span
              >
              <b-badge
                @click="excluirArquivo(fluxoDetalhadoGED)"
                href="javascript:;"
                class="mr-1"
                variant="danger"
                style="margin-left: 10px;"
              >
                Excluir
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-form-group>

        <b-form-group v-if="loadingGED">
          <Loading :modoPR="fgModoPR" tamanho="100px" />
        </b-form-group>

        <vue-dropzone
          @vdropzone-success="uploadGedSuccess"
          id="dropzone-ged"
          v-if="exibirUploadGED"
          :options="dropzoneOptions"
          :useCustomSlot="true"
          style="margin-bottom: 20px; border-radius: 10px; cursor: pointer;"
        >
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
              Solte arquivos aqui ou clique para fazer o upload
            </h3>
            <div class="subtitle">
              ...ou clique aqui para selecionar um arquivo do seu dispositivo
            </div>
          </div>
        </vue-dropzone>

        <b-button
          class="margin-btn-5 btn-block"
          @click="exibirUploadGED = !exibirUploadGED"
          :variant="'info'"
        >
          {{
            exibirUploadGED
              ? "Encerrar Associação Arquivo (GED)"
              : "Associar Arquivo (GED)"
          }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.dropzone-custom-content {
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>

<script>
import JwtService from "@/core/services/jwt.service";
import moment from "moment";

import { mapGetters, mapActions } from "vuex";
import Loading from "@/../../components-spirit/Loading/Loading.vue";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "GED",
  data() {
    return {
      loadingGED: false,
      exibirUploadGED: false,
      fluxoDetalhadoGEDs: [],
      urlDefaultDropzone:
        "https://console.doclogos.com/paylogosPlataformaAPI/importarGED",
      // urlDefaultDropzone: 'http://localhost/console-spirit/paylogosPlataformaAPI/importarGED',
      dropzoneOptions: {
        url: "https://console.doclogos.com/paylogosPlataformaAPI/importarGED",
        // url: 'http://localhost/console-spirit/paylogosPlataformaAPI/importarGED',
        thumbnailWidth: 150,
        maxFilesize: 10,
        headers: {
          Authorization: "Token " + JwtService.getToken()
        }
      }
    };
  },
  props: ["idEmitente", "idFluxoDeCaixa"],
  components: {
    Loading,
    vueDropzone: vue2Dropzone
  },
  mounted() {
    if (this.idEmitente && this.idFluxoDeCaixa) {
      this.dropzoneOptions.url =
        this.urlDefaultDropzone +
        "/" +
        this.idEmitente +
        "/" +
        this.idFluxoDeCaixa;

      this.buscarGED();
    }
  },
  computed: {
    ...mapGetters(["fgModoPR"])
  },
  methods: {
    ...mapActions(["getGED", "getGEDFile", "getExcGEDFile"]),
    formataDataPadrao(data) {
      if (data) {
        return moment(data, "YYYY-MM-DD HH:mm:ss").format(
          "DD/MM/YYYY [às] HH:mm:ss"
        );
      } else {
        return "";
      }
    },
    async buscarGED() {
      this.loadingGED = true;
      this.fluxoDetalhadoGEDs = await this.getGED(this.idFluxoDeCaixa);
      this.loadingGED = false;
    },
    uploadGedSuccess() {
      this.buscarGED();
    },
    async baixarArquivo(ged) {
      let arquivo = await this.getGEDFile(ged.TOKEN);
      let ext = ged.CAMINHO.split(".")
        .pop()
        .toUpperCase();
      let filename = ged.NOME_ARQUIVO;

      let contentType = "";
      if (ext == "GIF") {
        contentType = "image/gif";
      } else if (ext == "PNG") {
        contentType = "image/png";
      } else if (ext == "JPEG") {
        contentType = "image/jpeg";
      } else if (ext == "JPG") {
        contentType = "image/jpg";
      } else if (ext == "PDF") {
        contentType = "application/pdf";
      }

      const blob = new Blob([arquivo], { type: contentType });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async excluirArquivo(ged) {
      this.loadingGED = true;
      await this.getExcGEDFile(ged.TOKEN);
      this.buscarGED();
    }
  }
};
</script>
